module.exports = __webpack_public_path__ + "static/img/v-code-wza.ebbe96a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/v-code-wza.png
// module id = TyyR
// module chunks = 1